import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface Props {
  children: ReactNode
  className?: string
}

/** Centered content wrapper: max 1680px (2200 on ultra-wide) with responsive padding. */
export function PageContainer({ children, className }: Props) {
  return (
    <div className={cn('mx-auto w-full max-w-content ultra:max-w-content-ultra px-3 py-3 sm:px-4 sm:py-4', className)}>
      {children}
    </div>
  )
}
